import React, { useState, useEffect, useMemo,useCallback } from "react";
import { ToastContainer } from "react-toastify";

import { Button } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import Table from "../../components/table/ReactTable/Table";

import { ColumnFilter } from "../../components/table/ReactTable/ColumnFilter";
import { Badge } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { productActions } from "../../../_store";

import generatePDF from "../../components/export/generatePDF";
import generateXlsx from "../../components/export/generateXlsx";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

const ProductList = () => {
  const dispatch = useDispatch();

  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // #region ------------------  Reducer --------------------------------

  const productReports = useSelector((x) => x.product.productList);
 
  const isLoading = useSelector((x) => x.product.isLoading);

  // #endregion ------------------  Reducer End --------------------------------

  const PRODUCTS_COLUMNS = [
    {
      Header: "Warehouse",
      Footer: "Warehouse",
      accessor: "WareHouseNumber",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "Category",
      Footer: "Category",
      accessor: "CategoryName",
      justify: "center",
      Filter: ColumnFilter,
    },

    {
      Header: "Product Name",
      Footer: "Product Name",
      accessor: "ProductName",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "SKU",
      Footer: "SKU",
      accessor: "SKU",
      justify: "center",
      Filter: ColumnFilter,
    },

    {
      Header: "Package type",
      Footer: "Package type",
      accessor: "PackageType",
      justify: "center",
      Filter: ColumnFilter,
    },
    {
      Header: "stock Quantity",
      Footer: "stock Quantity",
      accessor: "StockQuantityStr",
      justify: "center",
      fieldType: "commaSeparator",
      Cell: ({ row }) => {
        return (
          <>
            <div>
              {row.original.StockQuantity <= 0 ? (
                <Badge
                  variant="danger"
                  style={{ background: "#e42313", border: "#e42313" }}
                >
                  {row.original.StockQuantityStr}
                </Badge>
              ) : (
                <Badge
                  variant="success"
                  style={{ background: "#48A23F", border: "#48A23F" }}
                >
                  {row.original.StockQuantityStr}
                </Badge>
              )}
            </div>
          </>
        );
      },
      Filter: ColumnFilter,
    },
    {
      Header: "Suggested Order",
      Footer: "Suggested Order",
      accessor: "SuggestedOrderStr",
      justify: "center",
      fieldType: "commaSeparator",
      // Cell: ({ value }) => { return fNumber(value) },
      Filter: ColumnFilter,
    },
    // {
    //     Header: 'High Quantity',
    //     Footer: 'High Quantity',
    //     accessor: 'HighStockThreshold',
    //     Filter: ColumnFilter,

    // },

    // {
    //     Header: 'Created Date',
    //     Footer: 'Created Date',
    //     accessor: 'CreatedDate',
    //     Cell: ({ value }) => { return format(new Date(value), 'MM/dd/yyyy') },
    //     Filter: ColumnFilter,
    // },

    // {
    //     Header: 'Active',
    //     Footer: 'Active',
    //     accessor: 'Active',
    //     Cell: ({ value }) => {
    //         return <>
    //             <Badge variant="primary light badge-lg"> {value}</Badge>
    //         </>

    //     },
    //     Filter: ColumnFilter,
    // },
    // {
    //     Header: '',
    //     Footer: '',
    //     accessor: 'ProductID',
    //     disableFilters: true,
    //     Cell: ({ row }) => {

    //         return <>
    //             <div className="d-flex">
    //                 <a onClick={() => handleEditClick(row.original)} title="Edit"
    //                     className="btn btn-primary shadow btn-xs sharp me-1"
    //                 >
    //                     <i className="fas fa-pen"></i>
    //                 </a>
    //                 {row.original.StockQuantity === 0 ?
    //                     <a
    //                         onClick={() => handleDeleteClick(row.original)}
    //                         className="btn btn-danger shadow btn-xs sharp" title="Delete"
    //                     >
    //                         <i className="fa fa-trash" ></i>
    //                     </a> : ""

    //                 }

    //             </div>
    //         </>

    //     }

    // }
  ];
  const generateColumns = [
    {
      header: "Warehouse",
      dataKey: "WareHouseNumber",
    },
    {
      header: "Category",
      dataKey: "CategoryName",
    },
    {
      header: "Product Name",
      dataKey: "ProductName",
    },
    {
      header: "SKU",
      dataKey: "SKU",
    },
    {
      header: "Package type",
      dataKey: "PackageType",
    },
    {
      header: "Stock Quantity",
      dataKey: "StockQuantityStr",
    },
    {
      header: "Suggested Order",
      dataKey: "SuggestedOrderStr",
    },
  ];
  useEffect(() => {
    showLoader();
    
    dispatch(productActions.getProductAll(startEndDate));
  }, [dispatch]);
 

  useEffect(() => {
    if (isLoading) {
      hideLoader();
    }
  }, [isLoading]);
  

  const columns = useMemo(() => PRODUCTS_COLUMNS, []);

  const [startEndDate, setStartEndDate] = useState({
    FromDate: new Date(),
    ToDate: new Date(),
    Status: 0,
  });

  
const [finalTableData, setFinalTableData] = useState([]);
 const handleTableDataUpdate = useCallback((data) => {
        setFinalTableData(data);
      }, []);
  

 
  ///  export  //
  const handleClickPDF = () => {
    let title = "Product Reports";

    const columnStyles = {
      WareHouseNumber: { halign: "center", cellWidth: 30 },
      CategoryName: { halign: "center", cellWidth: 30 },
      ProductName: { halign: "center", cellWidth: 40 },
      SKU: { halign: "center", cellWidth: 40 },
      PackageType: { halign: "center", cellWidth: 40 },
      StockQuantityStr: { halign: "center", cellWidth: 40 },
      SuggestedOrderStr: { halign: "center", cellWidth: 40 },
    };
   
      generatePDF(finalTableData, generateColumns, true, title, columnStyles
    );
  };
  const handleClickExcel = () => {
    let title = "ProductReports";
    let generateExcelColumns = [
      "Warehouse",
      "Category",
      "Product Name",
      "SKU",
      "Package type",
      "Stock Quantity",
      "SuggestedOrder",
    ];
    let new_productReports =
      finalTableData &&
      finalTableData.map(function (obj) {
        return {
          WareHouseNumber: obj.WareHouseNumber,
          CategoryName: obj.CategoryName,
          ProductName: obj.ProductName,
          SKU: obj.SKU,
          PackageType: obj.PackageType,
          StockQuantity: obj.StockQuantityStr,
          SuggestedOrder: obj.SuggestedOrderStr,
        };
      });

    generateXlsx(new_productReports, generateExcelColumns, title);
  };

  return (
    <>
      <PageTitle activeMenu="Product Report" motherMenu="Products" />
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <h4 className="card-title header-title">Product Report</h4>
          <div className="float-sm-end">
            <Button
              className="me-2"
              variant="danger btn-rounded"
              onClick={handleClickPDF}
            >
              <span className="btn-icon-start text-danger">
                <i className="fa fa-solid fa-file-pdf"></i>
                {/* <i className="fa fa-regular fa-file-excel"></i> */}
              </span>
              PDF
            </Button>
            <Button
              className="me-2"
              variant="secondary btn-rounded"
              onClick={handleClickExcel}
            >
              <span className="btn-icon-start text-secondary">
                {/* <i className="fa fa-solid fa-file-pdf"></i> */}
                <i className="fa fa-regular fa-file-excel"></i>
              </span>
              Excel
            </Button>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            {/* <div className="col-lg-3 col-md-8 mb-3">
                            <div className="example rangeDatePicker ms-2">
                                <p className="mb-1 text-black font-w500 productDate">Product Date Range</p>
                                <RangeDatePicker
                                    initialStartDate={startEndDate.FromDate ? startEndDate.FromDate : new Date()}
                                    initialEndDate={startEndDate.ToDate ? startEndDate.ToDate : new Date()}
                                    name="StartEndDate"
                                    startText="Start"
                                    endText="End"
                                    dateFormat="MM/DD/YYYY"
                                    startPlaceholder="Start Date"
                                    endPlaceholder="End Date"
                                    portal
                                    onChange={onChangeRangeValue("date")}

                                />
                            </div>
                        </div> */}
            {/* <div className="col-md-3 mb-2">
                            <div className="d-flex mt-5">
                                <a className="btn btn-primary shadow btn-xs sharp me-1" title="Search" onClick={() => handleRangeDateSearch()} >
                                    <i className="fas fa-search"></i>
                                </a>
                                {/* <a className="btn btn-danger shadow btn-xs sharp" title="Delete" onClick={() => handleRangeDateClear()} >
                                    <i className="fas fa-times"></i></a> */}
            {/* </div> */}
            {/* </div>  */}
          </div>
          <Table columns={columns} data={productReports} onDataUpdate={handleTableDataUpdate} />
        </div>
      </div>

      {loader}
    </>
  );
};

export default ProductList;
